import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, theme } from "antd";
import { observer } from "mobx-react";
import { ChangePaymentDetailsForm } from "./changePaymentDetailsForm.js";
import { useStores } from "../../../../store/stores.js";
import { __, _i } from "../../../../utils/i18n.js";
const ChangePaymentDetailsModal = observer(({ subscription })=>{
    const { accountV2Store } = useStores();
    const { token } = theme.useToken();
    const close = ()=>accountV2Store.closeSubscriptionModal();
    const renewalDate = subscription.nextRenewalDateLabel;
    const strong = /*#__PURE__*/ _jsx("strong", {
        style: {
            color: token.colorTextHeading
        }
    });
    const subtitle = subscription.isPastDue ? _i(__("We couldn't process the last renewal payment for this subscription. {{strong}}Add a working payment method to keep your subscription active!{{/strong}}"), {
        strong
    }) : _i(__("We'll switch to this method at your next renewal on %s. {{strong}}No charge today.{{/strong}}", renewalDate), {
        strong
    });
    return /*#__PURE__*/ _jsx(Modal, {
        open: true,
        title: /*#__PURE__*/ _jsxs("div", {
            style: {
                paddingTop: 4
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        fontSize: 16,
                        fontWeight: 600,
                        color: token.colorTextHeading
                    },
                    children: __("Payment method")
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        fontSize: 14,
                        fontWeight: 400,
                        color: token.colorText,
                        marginTop: 14,
                        lineHeight: 1.6
                    },
                    children: subtitle
                })
            ]
        }),
        onCancel: close,
        footer: null,
        destroyOnClose: true,
        width: 640,
        children: /*#__PURE__*/ _jsx(ChangePaymentDetailsForm, {
            subscription: subscription,
            onClose: close
        })
    });
});
export { ChangePaymentDetailsModal };
